import React from 'react';
import { 
  Add 
} from '@mui/icons-material';

import BaseButton from './BaseButton';

interface Props extends React.ComponentPropsWithoutRef<'div'> {
  disabled?: boolean;
  label?: string;
  label_separate?: boolean;
  no_fab?: boolean;
  fab?: boolean;
  link_url?: string;
  onClick: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement> | undefined) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLAnchorElement> | React.MouseEvent<HTMLDivElement>) => void;
}

export default function AddButton(props: Props) {
  const pass_along_props = {...props};
  return (
    <BaseButton
      icon={<Add />}
      {...pass_along_props}
    />
  );
}
